import { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input, type InputProps } from '@eombor/ui';
import { t } from '../i18n/index.js';

export type PasswordInputProps = Omit<InputProps, 'type' | 'suffix'>;

/**
 * Parol maydoni — KO'ZCHA bilan.
 *
 * Vaqtinchalik parol Telegramdan yoki ekrandan qo'lda ko'chiriladi va uni
 * ko'rmasdan terish oson emas: nuqtalar ortida bitta belgi tushib qolgani
 * bilinmaydi, odam esa "parol noto'g'ri" xabarini oladi va uchinchi
 * urinishdan keyin hisobi qulflanadi. Ko'zcha aynan shu yo'lni yopadi.
 *
 * Standart holat — YASHIRIN: yonida turgan odam parolni o'qib olmasin,
 * ochish esa foydalanuvchining ongli tanlovi bo'lsin.
 *
 * `@eombor/ui` dagi `Input` ning `suffix` o'ramida `pointer-events-none`
 * bor (u yerda suffiks — belgi, boshqaruv emas), shuning uchun tugmaning
 * o'zida `pointer-events-auto` qaytariladi.
 *
 * Yorliqlar `login.passwordShow` / `login.passwordHide` dan olinadi: ko'zcha
 * ilgari faqat kirish sahifasida bor edi va shu komponent o'sha takrorlangan
 * bo'lakning o'rniga keldi — kalitlarni ikkilantirish uchun sabab yo'q.
 */
export const PasswordInput = (props: PasswordInputProps) => {
  const [shown, setShown] = useState(false);

  return (
    <Input
      {...props}
      type={shown ? 'text' : 'password'}
      suffix={
        <button
          type="button"
          aria-label={t(shown ? 'login.passwordHide' : 'login.passwordShow')}
          aria-pressed={shown}
          onClick={() => setShown((value) => !value)}
          className="text-text-faint hover:text-text pointer-events-auto rounded-[var(--radius-sm)] p-1 transition-colors duration-[var(--motion-fast)] ease-[var(--ease-standard)]"
        >
          {shown ? <EyeOff size={16} aria-hidden /> : <Eye size={16} aria-hidden />}
        </button>
      }
    />
  );
};
